import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { withGenericConfig } from "contexts/generic-config-context";
import ArrowLeft from "static/svg/arrow-left-v2.svg";
import { preventFocusOnMouseDown } from "client/services/accessibility/accessibility-service";
import classnames from "classnames";
import { StyledSubmenuHeaderBar } from "./submenu-header-component.scss";
const closeIcon = /*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("span", {
            className: "close-line"
        }),
        /*#__PURE__*/ _jsx("span", {
            className: "close-line"
        })
    ]
});
const SubmenuHeaderComponent = ({ onBack, onClose, title, translate, isVisible })=>/*#__PURE__*/ _jsxs(StyledSubmenuHeaderBar, {
        className: classnames("submenu-header-bar", {
            "is-visible": isVisible
        }),
        children: [
            /*#__PURE__*/ _jsx("button", {
                className: "submenu-header-back",
                onClick: onBack,
                onMouseDown: preventFocusOnMouseDown,
                "aria-label": translate("header.back"),
                children: /*#__PURE__*/ _jsx(ArrowLeft, {
                    className: "arrow-left-icon"
                })
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "submenu-header-title",
                children: title
            }),
            /*#__PURE__*/ _jsx("button", {
                className: "submenu-header-close",
                onClick: onClose,
                onMouseDown: preventFocusOnMouseDown,
                "aria-label": translate("header.closeMenu"),
                children: closeIcon
            })
        ]
    });
export default withGenericConfig(SubmenuHeaderComponent);
